'use client';

import { LockedModule } from '../_components/LockedModule';

export default function AnalyticsPage() {
  return (
    <LockedModule
      tier="Pro"
      title="הכירו את הביצועים שלכם"
      description="דשבורד ניתוח מתקדם: הכנסות, תפוסה, שיעורי אי-הגעה ועוד - כל מה שצריך כדי לצמוח. זמין בתוכנית Pro."
    />
  );
}
